export default {"src":"/uk/_next/static/media/pensionbeelogo-transparent.26eef9b5.svg","height":53,"width":160,"blurWidth":0,"blurHeight":0};